"use client";

import React from "react";
import styles from "./CrmCustomDevelopment.module.css";

const BRAND = "#F48428";

export default function CrmCustomDevelopment() {
  return (
    <section className={`${styles.section} py-5`} style={{ "--brand": BRAND }}>
      <div className="container">
        <header className={styles.head}>
          <div className={styles.eyebrow}>CRM AS PER YOUR NEED</div>
          <h2 className={styles.title}>Custom CRM Development</h2>
        </header>

        <div className={styles.grid}>
          {/* Build a new CRM */}
          <article className={styles.card} data-reveal="slide-up">
            <div className={styles.iconWrap} aria-hidden>
              <i className="fa-solid fa-laptop-code"></i>
            </div>
            <h4>Build a new CRM</h4>
            <ul className={styles.list}>
              <li>Develop a CRM tailored to your business needs.</li>
              <li>Seamlessly integrate with existing tools for better productivity.</li>
              <li>Create an intuitive interface that requires minimal training for users.</li>
              <li>Implement robust security measures to protect customer data.</li>
              <li>Automate tasks like data entry, email marketing, and lead tracking to boost efficiency.</li>
              <li>Provide powerful reporting tools for insightful analytics and performance metrics.</li>
            </ul>
          </article>

          {/* Enhance your Existing CRM */}
          <article className={styles.card} data-reveal="slide-up">
            <div className={styles.iconWrap} aria-hidden>
              <i className="fa-solid fa-layer-group"></i>
            </div>
            <h4>Enhance your Existing CRM</h4>
            <ul className={styles.list}>
              <li>Add missing features to enhance CRM functionality.</li>
              <li>Update the user interface for better usability and modern aesthetics.</li>
              <li>Implement tools to maintain data hygiene and cleanliness.</li>
              <li>Enhance mobile access and functionality for any device.</li>
              <li>Strengthen security protocols to protect against new threats.</li>
              <li>Provide training materials and extended support for users.</li>
            </ul>
          </article>

          {/* Advanced CRM solutions */}
          <article className={styles.card} data-reveal="slide-up">
            <div className={styles.iconWrap} aria-hidden>
              <i className="fa-solid fa-chart-line"></i>
            </div>
            <h4>Advanced CRM solutions</h4>
            <ul className={styles.list}>
              <li>Use AI to predict customer behavior, automate decisions, and personalize interactions.</li>
              <li>Implement blockchain for data integrity and secure transactions.</li>
              <li>Utilize advanced analytics for customer insights and trend analysis.</li>
              <li>Offer a cloud‑based CRM for better scalability, flexibility, and remote access.</li>
              <li>Develop custom APIs for unique integrations, enhancing connectivity.</li>
              <li>Connect CRM with IoT devices for real‑time data collection.</li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}
